import script from "./PrestationInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrestationInfo.vue?vue&type=script&setup=true&lang=ts"

import "./PrestationInfo.vue?vue&type=style&index=0&id=4cfa465d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cfa465d"]])

export default __exports__